import { makeStyles } from '@material-ui/core/styles';

export const useProductTicketContainerStyles = makeStyles(() => ({
  icon: {
    height: 20,
    width: 20,
    marginRight: 7,
  },
}));

export const useProductTicketStyles = makeStyles(() => ({
  container: {
    border: '1px solid #5B73BA',
    backgroundColor: '#5B73BA1F',
    borderRadius: (props) => (props.mobile ? '0px' : '0px 0px 8px 8px'),
  },
}));

export const useProductTicketFooter = makeStyles(() => ({
  container: {
    backgroundColor: '#5B73BA33',
    borderRadius: (props) => (props.mobile ? '0px' : '0px 0px 8px 8px'),
  },
}));
